module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0113.jpg?v=b3d6378d";